import React from "react";
import {
    Button,
    Card,
    Input,
    Table,
} from "antd";
import {Link} from "react-router-dom";
import { SearchOutlined } from '@ant-design/icons';

import memory from "../../../../../utils/memory";
import LinkButton from "../../../../crm/components/link-button";
import {moaApi} from "../../../../../api";
import {
    CAPITALLEVEL,
    CAPITALLEVELSIMPLE,
    THREADSTATUS
} from "../../../../../utils/constant";
import tools from "../../../../../utils/tools";

const {
    reqFundList
} = moaApi;

export default class ThreadList extends React.Component {
    state = {
        data: [],
        pagination: {},
        loading: false,
    };

    handleTableChange = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager
        });
        let tmpFilters = {...filters};
        for(let item in tmpFilters) {
            if(tmpFilters[item]) {
                if(typeof(tmpFilters[item]) !== 'string') {
                    tmpFilters[item] = tmpFilters[item][0];
                }
            }
        }
        let params = {
            page: pagination.current,
            ...tmpFilters,
        };
        if(sorter && sorter.field) {
            if(sorter.order === 'ascend') {
                params[sorter.field] = -1;
            }else if(sorter.order === 'descend') {
                params[sorter.field] = 1;
            }
        }
        this.getFundList(params);
    }

    /*
    *搜索相关
    * */
    getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`搜索 ${title}`}
                    value={selectedKeys ? selectedKeys[0] : ''}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    搜索
                </Button>
                <Button onClick={() => this.handleReset(clearFilters, confirm)} size="small" style={{ width: 90 }}>
                    重置
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text => text
    });
    handleSearch = (selectedKeys, confirm) => {
        confirm();
    };
    handleReset = (clearFilters, confirm) => {
        clearFilters();
        confirm();
    };

    getFundList = async (params = {}) => {
        this.setState({
            loading: true
        });
        const response = await reqFundList(params);
        const pagination = {...this.state.pagination};
        const data = response.data;
        pagination.total = data.page.total;
        pagination.pageSize = data.page.node;
        let newData = [];
        for(let i = 0; i < data.data.length; i++) {
            const item = data.data[i];
            let group = [];
            if(item.response_unit && item.response_unit.length) {
                for(let j = 0; j < item.response_unit.length; j++) {
                    group.push(item.response_unit[j].name);
                }
            }
            const obj = {
                key: item._id,
                fund_date: item.fund_date,
                fund_name: item.fund_name,
                fund_grade: CAPITALLEVEL[item.fund_grade-1].text,
                group: group.length ? group.join('、') : '-',
                provider: item.clue_provider && item.clue_provider.name ? item.clue_provider.name : '-',
                capital_all: item.fund_amount + '元',
                capital_in: item.arrived_amount + '元',
                payoff: item.expenses_amount + '元',
                create_time: tools.unixToTime((new Date(item.create_at)).getTime()/1000),
                status: item.status ? THREADSTATUS[item.status-1].text : '-'
            };
            newData.push(obj);
        }
        this.setState({
            loading: false,
            data: newData,
            pagination
        });
    };

    columns = [
        {
            title: '资金申报年份',
            dataIndex: 'fund_date',
            key: 'fund_date',
            sorter: (a, b) => a - b,
        },
        {
            title: '资金名称',
            dataIndex: 'fund_name',
            key: 'fund_name',
            ...this.getColumnSearchProps('fund_name', '资金名称'),
            render: (text, record) => {
                return (
                    <Link to={`/moa/capital/thread/detail/${record.key}`}>
                        <span className="text-overflow" style={{maxWidth: 500}} title={text}>{text}</span>
                    </Link>
                );
            }
        },
        {
            title: '资金量级',
            dataIndex: 'fund_grade',
            key: 'fund_grade',
            filters: CAPITALLEVELSIMPLE,
            filterMultiple: false,
        },
        {
            title: '负责单位',
            dataIndex: 'group',
            key: 'group',
        },
        {
            title: '线索提供人',
            dataIndex: 'provider',
            key: 'provider',
        },
        {
            title: '创建时间',
            dataIndex: 'create_time',
            key: 'create_time',
        },
        {
            title: '线索状态',
            dataIndex: 'status',
            key: 'status',
            filters: THREADSTATUS,
            filterMultiple: false,
        },
        {
            title: '操作',
            dataIndex: 'option',
            valueType: 'option',
            render: (_, record) => {
                return (
                    <Link to={`/moa/capital/thread/detail/${record.key}`}>详情</Link>
                );
            }
        },
    ];

    componentDidMount() {
        this.getFundList({
            page: 1,
        });
    }

    render() {
        return (
            <Card
                title="线索列表"
                bordered={false}
                extra={<LinkButton to="/moa/capital/thread/add" txt="添加线索" />}
            >
                <Table
                    columns={this.columns}
                    dataSource={this.state.data}
                    pagination={this.state.pagination}
                    loading={this.state.loading}
                    onChange={this.handleTableChange}
                    scroll={{ x: 'max-content' }} // 加上这条  横向滚动  支持此属性的浏览器内容就不会换行了
                    size={memory.is_mobile ? 'small' : 'middle'}
                />
            </Card>
        );
    }
}